
import { Component, Prop, Vue } from 'vue-property-decorator';
import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { schedule12DataInfoType } from '@/types/Application/FamilyLawMatter/Pdf';
import { companionAnimalExistingAgreementDataInfoType } from '@/types/Application/FamilyLawMatter/CompanionAnimal';
import GreyBoxForm from '@/components/utils/PopulateForms/components/GreyBoxForm.vue';
import ScheduleHeader from '@/components/utils/PopulateForms/components/ScheduleHeader.vue';
import FormPart from '@/components/utils/PopulateForms/components/FormPart.vue';
import NoteBox from '@/components/utils/PopulateForms/components/NoteBox.vue';

@Component({
    components:{
        UnderlineForm,
        CheckBox,
        GreyBoxForm,
        ScheduleHeader,
        FormPart,
        NoteBox
    }
})

export default class Schedule12 extends Vue {

    @Prop({required:true})
    result!: any; 
   
    dataReady = false;
    exCompInfo = {} as schedule12DataInfoType;
   
    mounted(){
        this.dataReady = false;      
        this.extractInfo();       
        this.dataReady = true;        
    }    

    public extractInfo(){ 
        this.exCompInfo = this.getExCompanionAnimalInfo(); 
    }

    public getExCompanionAnimalInfo(){
       
        let exCompInfo = {} as schedule12DataInfoType;

        exCompInfo = {
            agreementDate: '',
            reason: '',
            replace: false,
            agreementReplacementDetails: '',
            setAside: false
        }

        if (this.result.companionAnimalExistingAgreementSurvey){
            const exCompData: companionAnimalExistingAgreementDataInfoType = this.result.companionAnimalExistingAgreementSurvey;
            
            exCompInfo.agreementDate = Vue.filter('beautify-date')(exCompData.agreementDate);
            exCompInfo.reason = exCompData.setAsideReason;
            exCompInfo.replace = exCompData.existingAgreementDecision == 'Replaced';
            exCompInfo.setAside = exCompData.existingAgreementDecision == 'SetAside';
            if (exCompInfo.replace){
                exCompInfo.agreementReplacementDetails = exCompData.agreementReplacement?exCompData.agreementReplacement:'';
            }
        }

       return exCompInfo;
   } 

}
